export const cleanText = (value) => {
    return value.replace(/[^a-zA-Z0-9 .,_':;?<>(){}=|`~+\-&*%#@!$]/g, "");
    
};